"use strict";
/*
 * Copyright (C) 2017-2020 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.webMercatorTilingScheme = void 0;
const MercatorProjection_1 = require("../projection/MercatorProjection");
const QuadTreeSubdivisionScheme_1 = require("./QuadTreeSubdivisionScheme");
const TilingScheme_1 = require("./TilingScheme");
/**
 * A {@link TilingScheme} featuring quadtree subdivision scheme and web Mercator projection.
 */
exports.webMercatorTilingScheme = new TilingScheme_1.TilingScheme(QuadTreeSubdivisionScheme_1.quadTreeSubdivisionScheme, MercatorProjection_1.webMercatorProjection);
//# sourceMappingURL=WebMercatorTilingScheme.js.map